export default __webpack_public_path__ + "static/media/table.3d3d68aa.jpg";